import React, { useState, useEffect } from 'react';
import DesktopLayout from './Landing';
import MobileLayout from './MLanding';

function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);
  
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return width;
}

function App() {
  const width = useWindowWidth();
  const isDesktop = width > 768;

  return (
    <div className="app">
      {isDesktop ? <DesktopLayout /> : <MobileLayout />}
    </div>
  );
}

export default App;
